import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import { PaymentCheckoutPaymentMethodsResponse } from 'src/models';

export function getAvailablePaymentMethods() {
  return axios.request<PaymentCheckoutPaymentMethodsResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/payment-checkout/payment-methods`,
  });
}
